// import React from "react";
// import DataTable from "examples/Tables/DataTable";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import { Card } from "@mui/material";

// const History = ({ subscriptionHistory }) => {
//   if (!subscriptionHistory || subscriptionHistory.length === 0) {
//     return (
//       <MDBox mt={3}>
//         <MDTypography variant="body2" color="textSecondary">
//           No subscription history available.
//         </MDTypography>
//       </MDBox>
//     );
//   }

//   // Define table columns with bold headers
//   const columns = [
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>PLAN NAME</MDTypography>, 
//       accessor: "plan", 
//       align: "left" 
//     },
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>BILLING CYCLE</MDTypography>, 
//       accessor: "billing_cycle", 
//       align: "left" 
//     },
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>START DATE</MDTypography>, 
//       accessor: "start_date", 
//       align: "left" 
//     },
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>END DATE</MDTypography>, 
//       accessor: "end_date", 
//       align: "left" 
//     },
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>RENEWAL DATE</MDTypography>, 
//       accessor: "next_renewal_date", 
//       align: "left" 
//     },
//     { 
//       Header: <MDTypography variant="caption" sx={{ fontWeight: 800 }}>STATUS</MDTypography>, 
//       accessor: "status", 
//       align: "left" 
//     },
//   ];


//   // Format data into rows
//   const rows = subscriptionHistory.map((sub) => ({
//     plan: sub.plan,
//     billing_cycle: sub.billing_cycle,
//     start_date: new Date(sub.start_date).toLocaleDateString(),
//     end_date: sub.end_date ? new Date(sub.end_date).toLocaleDateString() : "N/A",
//     next_renewal_date: new Date(sub.next_renewal_date).toLocaleDateString(),
//     status: sub.status,
//   }));

//   return (
//     <Card>
//       <MDBox p={1}>
//         <MDTypography variant="h6" fontWeight="bold" textAlign="center">
//           Subscription History
//         </MDTypography>
//       </MDBox>
//       <MDBox>
//         <DataTable
//           table={{ columns, rows }}
//           showTotalEntries={false}
//           isSorted={false}
//           noEndBorder
//           entriesPerPage={5}
//         />
//       </MDBox>
//     </Card>
//   );
// };

// export default History;

import React from "react";
import DataTable from "examples/Tables/DataTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const History = ({ subscriptionHistory, onClose }) => {
  if (!subscriptionHistory || subscriptionHistory.length === 0) {
    return (
      <MDBox mt={3}>
        <MDTypography variant="body2" color="textSecondary">
          No subscription history available.
        </MDTypography>
      </MDBox>
    );
  }

  // Define table columns with bold headers
  // const columns = [
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>PLAN NAME</MDTypography>, accessor: "plan", align: "left" },
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>BILLING CYCLE</MDTypography>, accessor: "billing_cycle", align: "left" },
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>START DATE</MDTypography>, accessor: "start_date", align: "left" },
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>END DATE</MDTypography>, accessor: "end_date", align: "left" },
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>RENEWAL DATE</MDTypography>, accessor: "next_renewal_date", align: "left" },
  //   { Header: <MDTypography variant="caption" sx={{ fontWeight: 800, pl:3 }}>STATUS</MDTypography>, accessor: "status", align: "left" },
  // ];

  const columns = [
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            PLAN NAME
          </MDTypography>
        </MDBox>
      ),
      accessor: "plan",
      align: "left"
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            BILLING CYCLE
          </MDTypography>
        </MDBox>
      ),
      accessor: "billing_cycle",
      align: "left"
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            START DATE
          </MDTypography>
        </MDBox>
      ),
      accessor: "start_date",
      align: "left"
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            END DATE
          </MDTypography>
        </MDBox>
      ),
      accessor: "end_date",
      align: "left"
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            RENEWAL DATE
          </MDTypography>
        </MDBox>
      ),
      accessor: "next_renewal_date",
      align: "left"
    },
    {
      Header: (
        <MDBox py={1} px={2} pl={3}>
          <MDTypography variant="caption" sx={{ fontWeight: 800 }}>
            STATUS
          </MDTypography>
        </MDBox>
      ),
      accessor: "status",
      align: "left"
    },
  ];


  // Format data into rows
  const rows = subscriptionHistory.map((sub) => ({
    plan: sub.plan,
    billing_cycle: sub.billing_cycle,
    start_date: (sessionStorage.getItem('demo_role_cache') === "demo_viewer")
      ? new Date().toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-")
      : (sub.start_date ? new Date(sub.start_date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-") : "N/A"),
    end_date: sub.end_date ? new Date(sub.end_date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-") : "N/A",
    next_renewal_date: sub.next_renewal_date ? new Date(sub.next_renewal_date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }).replace(/ /g, "-") : "N/A",
    status: sub.status,
  }));

  return (
    <Card>
      {/* Title & Close Button */}
      <MDBox p={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="bold" textAlign="center" flexGrow={1}>
          Subscription History
        </MDTypography>

        {/* Close Button */}
        <IconButton onClick={onClose} sx={{ color: "gray" }}>
          <CloseIcon />
        </IconButton>
      </MDBox>

      <MDBox>
        <DataTable
          table={{ columns, rows }}
          showTotalEntries={false}
          isSorted={false}
          noEndBorder
          entriesPerPage={false}
        />
      </MDBox>
    </Card>
  );
};

export default History;

